<template>
  <el-popover placement="left" width="300" trigger="hover" @show="onShow">
    <div class="menu-overview-popper" v-loading="loading">
      <ul>
        <li v-for="item in list" :key="item.gid">
          <div class="name">{{item.serviceName}}</div>
          <div class="price">{{item.price}}元</div>
        </li>
      </ul>
    </div>
    <a href="javascript:" slot="reference">{{linkText}}</a>
  </el-popover>
</template>

<script>
export default {
  props: {
    linkText: {
      default() {
        return '菜单预览'
      }
    },
    restaurantId: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  mounted() {
    this.list = []
  },
  methods: {
    onShow() {
      if (!this.list.length) {
        this.loadData()
      }
    },
    loadData() {
      this.loading = true
      this.Service.call('serviceitem', 'GET', {
        index: 0,
        size: 10000,
        serviceprovidergid: this.restaurantId
      }).then(data => {
        this.list = data.data || []
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
